import { createSlice } from '@reduxjs/toolkit'
import { professionalTexts } from 'locale/es'
import ProfessionalsService from 'services/ProfessionalsService'
import { appendFullNames } from 'utils/HelperFunctions'
import { toast } from './notificationReducer'

const initialState = { data: [], loading: false, error: null }

const allProfessionalsSlice = createSlice({
  name: 'allProfessionals',
  initialState,
  reducers: {
    setAllProfessionals(state, action) {
      const { data } = action.payload

      return { ...state, data: appendFullNames(data), loading: false, error: null }
    },
    appendProfessional(state, action) {
      const { data } = action.payload

      return { ...state, data: [...state.data, ...appendFullNames([data.professional])], loading: false, error: null }
    },
    removeProfessional(state, action) {
      const newDataState = state.data.filter((professional) => professional.id !== action.payload)

      return { ...state, data: newDataState, loading: false, error: null }
    },
    updateProfessional(state, action) {
      const newState = state.data.map(professional =>
        professional.id !== action.payload.professional.id ? professional : action.payload.professional
      )

      return { ...state, data: appendFullNames(newState), loading: false, error: null }
    },
    setProfessionalsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setProfessionalsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetProfessionalsState(state, action) {
      return initialState
    }
  }
})

export const { setAllProfessionals, appendProfessional, removeProfessional, updateProfessional, setProfessionalsLoading, setProfessionalsError, resetProfessionalsState } = allProfessionalsSlice.actions

export const initializeProfessionals = (centerId) => {
  return async (dispatch) => {
    try {
      dispatch(setProfessionalsLoading());

      const { data } = await ProfessionalsService.getProfessionalsByCenter(centerId)
      dispatch(setAllProfessionals({ data }))
    }
    catch (error) {
      console.error(error)
      dispatch(setProfessionalsError({ message: error.message, status: error.response?.status }));
      dispatch(toast(professionalTexts.LOADING_ERROR, 'error'))
    }
  }
}

export const createProfessionalAction = (professionalObj) => {
  return async (dispatch, getState) => {
    try {
      const { data } = await ProfessionalsService.createProfessional(professionalObj)
      const selectedCenterId = getState().center?.data?.id
      const currentCenterIsSelected = professionalObj.centerIds.find(id => id === selectedCenterId)

      if (currentCenterIsSelected) {
        dispatch(appendProfessional({ data }))
      }

      dispatch(toast(professionalTexts.CREATED, 'success'))
      return data;
    }
    catch (error) {
      console.error(error)
      dispatch(setProfessionalsError({ message: error.message, status: error.response?.status }));
      throw error
    }
  }
}

export const updateProfessionalAction = (fieldsToUpdate) => {
  return async (dispatch, getState) => {
    try {
      const updatedProfessional = await ProfessionalsService.updateProfessional(fieldsToUpdate.id, { ...fieldsToUpdate, professionalId: fieldsToUpdate.id })

      const selectedCenterId = getState().center?.data?.id

      const currentCenterIsSelected = fieldsToUpdate.centerIds.find(id => id === selectedCenterId)

      if (currentCenterIsSelected) {
        dispatch(updateProfessional(updatedProfessional.data))
      } else (
        dispatch(removeProfessional(fieldsToUpdate.id))
      )

      dispatch(toast(professionalTexts.EDITED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setProfessionalsError({ message: error.message, status: error.response?.status }));
      throw error
    }
  }
}

export const deleteProfessionalAction = (id) => {
  return async (dispatch) => {
    try {
      await ProfessionalsService.deleteProfessional(id)
      dispatch(removeProfessional(id))
      dispatch(toast(professionalTexts.DELETED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setProfessionalsError({ message: error.message, status: error.response?.status }));
      dispatch(toast(professionalTexts.DELETED_ERROR, 'error'))
    }
  }
}

export default allProfessionalsSlice.reducer